import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { REPORT_TENANT_CHANGE_RESOLVED } from '../../../../features/actions/Is-Logged-Actions';
import { 
    REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED, 
    //REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, 
    UPDATE_RESOLVED_BY_TECH_REPORT_OPEN_STATUS,
    UPDATE_RESOLVED_BY_TECH_SORTING
} from '../../../../features/actions/Reports-Actions';

import {
    Paper,
    Text,
    Table,
    Group,
    UnstyledButton,
    rem,
    Center,
    Collapse,
} from '@mantine/core';

import classes from '../../../TableSort.module.css';
import { IconSelector, IconChevronDown, IconChevronUp, IconLineDashed } from '@tabler/icons-react';

//import DashboardDataService from '../../../../services/dashboard-activities';
import HardwareTicketDataService from '../../../../services/hardware-ticket-activities';
//import { BarChart, AreaChart, PieChart, DonutChart } from '@mantine/charts';

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { useMantineTheme, useMantineColorScheme } from '@mantine/core';

import dayjs from 'dayjs';

const itemHeight = 120;

const CustomTooltip = ({ active, payload, label }) => {
    const theme = useMantineTheme();
    if (!active || !payload || payload.length === 0) return null;

    // background adapts to light/dark mode
    const backgroundColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white;
    const textColor =
        theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.black;
    const borderColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3];
    const seenNames = new Set();

    return (
      <div
        style={{
          width: 250,            // fixed width
          //maxWidth: 250,         // max width
          backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: 4,
          padding: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          pointerEvents: 'none', // prevents blocking hover interactions
          color: textColor
        }}
      >
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{label}</div>
        
        {payload.filter((entry) => {
            if (seenNames.has(entry.name)) return false;
            seenNames.add(entry.name);
            return true;
        }).map((entry, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', fontSize: 14, marginBottom: 2 }}>
            <span
                style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: entry.color,
                marginRight: 6,
                }}
            />
            <span style={{display: "flex", justifyContent: 'space-between', flex: 1}}><span>{entry.name}</span> <span>{entry.value}</span></span>
        </div>
        ))}
      </div>
    );
};

// Register required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
}

function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.timespanReportControl}>
                <Group justify="left"/* justify="space-between" */>
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}

// returns the count of resolved tickets by tech and displays in a chart (based on data recevied from reports resolved range drop down)
export default function ResolvedTicketCountByTech({props}) {
    const [data, setData] = useState([]);   // the raw data returned from backend for the table
    const [sortedData, setSortedData] = useState([]); //the data actually presented in the table
    const [labels, setLabels] = useState([]);
    const [dataValues, setDataValues] = useState([]);   // the data formatted specifically for the doughnut chart
    const [backgroundColors, setBackgroundColors] = useState([]);

    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const loggedStatus = useSelector((state) => state.logged);
    const activeNavLinkStatus = useSelector((state) => state.activeNav);
    const reportInfo = useSelector((state) => state.reports);

    const dispatch = useDispatch();

    function getTicketData() {
        if (loggedStatus.loggedIn) {
            //var today = new Date();
            //var startDate =  new Date("2020-01-01");
            
            //let dateRange = [startDate, today];

            if(reportInfo.resolved_timespan && reportInfo.timespanAssignedToArray && reportInfo.resolved_timespan.length > 1) {
                var timespan = [reportInfo.resolved_timespan[0] ? dayjs(Date.parse(reportInfo.resolved_timespan[0])).$d : null, reportInfo.resolved_timespan[1] ? dayjs(Date.parse(reportInfo.resolved_timespan[1])).$d : null]
    
                console.log("Timespan in getResolvedTickets: ", timespan);
                // generate the list of id numbers user has requested in the filter drop down
                let requesterIdList = [];
    
                for(let r = 0; r < reportInfo.timespanAssignedToArray.length; r++) {
                    requesterIdList.push(reportInfo.timespanAssignedToArray[r].value);
                }
    
                console.log("List of ids to send: ", requesterIdList);

                // right now I'm passing 0 for the tenant parameter (show all of them) Kyle's widgets don't currently obey the tenant selector. if we get more tenants, we'll need to change
                // hardcoding Resolved because that is the only type of ticket this widget is concerned with at all times
                HardwareTicketDataService.getResolvedTickets(loggedStatus.report_tenant_id_selected, timespan, "Resolved", requesterIdList, loggedStatus.id, loggedStatus.timezone_adjustment_factor)
                .then(response => {
                    console.log("Data returned by open count by tech widget was: ", response);
                    let processedData = {};

                    const counts = response.data.results.reduce((acc, { assigned_tech_name }) => {
                        const key = assigned_tech_name || 'Unassigned'; // treat null as "Unassigned"
                        acc[key] = (acc[key] || 0) + 1;
                        return acc;
                    }, {});

                    processedData = Object.entries(counts)
                    .map(([name, total]) => ({ name, total }))
                    .sort((a, b) => a.name.localeCompare(b.name));      // sort by tech name
                    //.sort((a, b) => b.total - a.total);               // sort by ticket count

                    if(processedData !== undefined && processedData !== null) {
                        setLabels(processedData.map((item) => item.name));
                        setDataValues(processedData.map((item) => item.total));
                        setBackgroundColors(processedData.map((item) => stringToColor(item.name)));
                    }
                    
                    setData(processedData);
                    setSortBy(reportInfo.resolved_by_tech_sort_by)
                    setSortOrder(reportInfo.resolved_by_tech_sort_order)

                    console.log("Overdue counts by tech object is: ", processedData);
                    
                    //sortTable(processedData, reportInfo.resolved_by_tech_sort_by, reportInfo.resolved_by_tech_sort_order);
                })
                .catch(e => {
                    console.log(e);
                });
            }
        }
    }

    useEffect(() => {
        getTicketData();
    }, []);

    function handleGlobalSortingChange(new_column_name) {
        dispatch(UPDATE_RESOLVED_BY_TECH_SORTING({sortBy: new_column_name}));
    }

    function handleReportOpenChange() {
        dispatch(UPDATE_RESOLVED_BY_TECH_REPORT_OPEN_STATUS());
    }

    // locally sorts the data displayed in the table based on the column clicked and sort order
    function sortTable(array, sortBy, sortOrder) {
        const sortedArray = [...array].sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "name") {
              aVal = aVal ?? "Unassigned";
              bVal = bVal ?? "Unassigned";
            }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        console.log("here is the sorted array: ", sortedArray);
        
        //return sortedArray;
        // this.setState({
        //     resolvedTickets: sortedArray
        // });
        setSortedData(sortedArray);
    }

    // fired when user clicks a table header - sorts resolved tickets by column and flips sort order
    function handleSortByAndOrderChange(new_column_name) {

        let newSortOrder;
        if(sortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== sortBy) {
            setSortBy(new_column_name);
            setSortOrder(newSortOrder);
            // this.setState({
            //     sortBy: new_column_name,
            //     sortOrder: newSortOrder,
            //     //offset: 0
            // }, () => this.sortTable(this.state.resolvedTickets, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            setSortOrder(newSortOrder);
            // this.setState({
            //     sortOrder: newSortOrder,
            //     //offset: 0
            // }, () => this.sortTable(this.state.resolvedTickets, this.state.sortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        //this.props.UPDATE_RESOLVED_SORTING({sortBy: new_column_name});
        handleGlobalSortingChange(new_column_name);
    }

    useEffect(() => {
        if(sortBy !== null && sortOrder !== null) {
            sortTable(data, sortBy, sortOrder);
        }
    }, [data, sortBy, sortOrder]);

    // Equivalent of componentDidUpdate for loggedStatus.report_tenant_change_detected
    useEffect(() => {
        if (loggedStatus.report_tenant_change_detected) {
            dispatch(REPORT_TENANT_CHANGE_RESOLVED());
            getTicketData();
        }
    }, [loggedStatus.report_tenant_change_detected, dispatch]); 
    // runs whenever report_tenant_change_detected changes

    // Equivalent of componentDidUpdate for reportInfo changes
    useEffect(() => {
        if (reportInfo.report_resolved_timespan_change_detected) {
            dispatch(REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED());
            console.log('resolved timespan change detected in child 3');
            getTicketData();
        }

        // Only fetch on assigned_to change (timespan_type change ignored)
        if (reportInfo.report_assigned_to_change_detected) {
            dispatch(REPORT_ASSIGNED_TO_CHANGE_RESOLVED());
            console.log('timespan assigned to change detected in child 3');
            getTicketData();
        }
    }, [
        reportInfo.report_resolved_timespan_change_detected,
        reportInfo.report_assigned_to_change_detected,
        dispatch
    ]);

    const theme = useMantineTheme();
    const { colorScheme } = useMantineColorScheme();

    const chartData = {
        labels,
        datasets: [
          {
            label: "Resolved Tickets",
            data: dataValues,
            backgroundColor: backgroundColors,
            borderColor: backgroundColors,
            borderWidth: 1,
          },
        ],
    };
    
    const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false
            /* position: "right",
            labels: {
                // Use a function to set label color dynamically
                color: colorScheme === 'dark' ? theme.colors.gray[0] : theme.black,
                font: {
                size: 14,
                weight: '500',
                },
            }, */
        }
    },
    };

    return (
        <Paper 
            withBorder 
            p="md" 
            radius="md" 
            onClick={() => handleReportOpenChange()}
            //display="block" 
            //m="5px" 
            // style={{
            //     display: "flex",
            //     alignItems: "center",
            //     justifyContent: "space-evenly", // even horizontal spacing
            //     gap: "2rem", // optional extra spacing
            //     height: "100%", // helps vertical centering if Paper has a fixed height
            // }}
        >
            <div><Text size="xl" fw={700} component="span">{`Resolved Ticket Count By Technician`}</Text>{reportInfo.resolved_by_tech_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
            {/* <Text p="20px" style={{textAlign: "center"}}>Resolved Ticket Count By Technician</Text> */}
            <Collapse in={reportInfo.resolved_by_tech_report_open}>
                <div style={{ 
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    gap: "2rem",
                    flexWrap: "wrap", // optional: allows wrapping on smaller screens
                }}>
                    <div style={{ width: 400, height: 400 }}>
                        <Doughnut data={chartData} options={options} />
                    </div>
                
                    <div style={{ flex: 1, maxWidth: 500 }}>
                        <Table>
                            <Table.Thead>
                                <Table.Tr>
                                    <Th 
                                        w="50%"
                                        sorted={sortBy === 'name'}
                                        reversed={sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); handleSortByAndOrderChange("name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={sortBy === "name" ? "activeMyAssignedTicketsHeader" : ""}>Name</div>
                                    </Th>
                                    <Th 
                                        w="50%"
                                        sorted={sortBy === 'total'}
                                        reversed={sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); handleSortByAndOrderChange("total")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={sortBy === "total" ? "activeMyAssignedTicketsHeader" : ""}>Resolved Total</div>
                                    </Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {sortedData && sortedData.map((tech, idx) => (
                                    <Table.Tr key={`${tech.name}-${idx}`}>
                                        <Table.Td>{tech.name}</Table.Td>
                                        <Table.Td>{tech.total}</Table.Td>
                                    </Table.Tr>
                                ))}
                            </Table.Tbody>
                        </Table>
                    </div>
                </div>
            </Collapse>
        </Paper>
    )

}